import { VOLUME_SAVE_API,VOLUME_ENABLE_API,VOLUME_API } from '../resource/index';
import axios from '../config/axios.config';
export default {

   async save(params) {
      return await axios.save(VOLUME_SAVE_API,{},params);
   },
  async enableOrDisable(params) {
    return await axios.update(VOLUME_ENABLE_API,params,{});
  },
  async fetchData(id, specifyModuleId = '') {
    return await axios.get(VOLUME_API,{id: id, specifyModuleId: specifyModuleId});
  }


}



// WEBPACK FOOTER //
// ./src/service/volumeService.js